export default __webpack_public_path__ + "static/media/vote.33284d83.svg";